// extracted by mini-css-extract-plugin
export default {"companyLabel":"style_companyLabel__ODjw6"};